import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr'; // Import ToastrModule if you're using toastr
import { NonPoiSettingsComponent } from './non-poi-settings.component'; // Adjust the path as necessary
import { NgxLoadingModule } from 'ngx-loading';
import { EmailManagerModule } from '../email-manager/email-manager.module';
import { CronSettingsModule } from '../cron-settings/cron-settings.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    NonPoiSettingsComponent,
  ],
  imports: [
    CommonModule, // Include CommonModule for Angular common directives
    FormsModule,   // Include FormsModule if you are using forms in the component
    ToastrModule.forRoot(), // Include ToastrModule for toast notifications
    NgxLoadingModule.forRoot({}),
    EmailManagerModule,
    CronSettingsModule,
    MatSlideToggleModule
  ],
  exports: [
    NonPoiSettingsComponent // Export the component if it needs to be used in other modules
  ]
})
export class NonPoiSettingsModule { }
